import sessionStorageKeys from "./consts/sessionStorageKeys";
import { LOCAL_VIEW_ID_PREFIX } from "@/consts/consts";

/**
 *
 * @param {alarmed: Boolean, armed: Boolean, attached: Boolean} socketStates
 */
export const getStateCamFromSocket = socketStates => {
  if (!socketStates) {
    return;
  }

  const { alarmed, armed, attached } = socketStates;
  if (!attached) {
    return "DETACHED";
  }

  if (alarmed) {
    return "ALARMED";
  }

  if (!armed) {
    return "DISARMED";
  }

  if (armed) {
    return "ARMED";
  }
};

export const getDate = (local = "ru") => {
  const numberLengthCheck = num =>
    !num ? "00" : `${num}`.length < 2 ? `0${num}` : num;

  const getMonth = date => {
    if (!date) return "";
    const longStringMonth = date.toLocaleString(local, { month: "long" });
    let sliceMonth = longStringMonth.slice(0, 3);
    if (sliceMonth === "май") {
      sliceMonth = sliceMonth.slice(0, 2) + "я";
    }
    const firstL = sliceMonth.slice(0, 1).toUpperCase();
    const secondL = sliceMonth.slice(1, 3).toLowerCase();
    return firstL + secondL;
  };

  const date = new Date("01.01.2022");
  const day = numberLengthCheck(date.getDate());
  const month = getMonth(date);
  const year = date.getFullYear();
  const hours = numberLengthCheck(date.getHours());
  const minutes = numberLengthCheck(date.getMinutes());
  const seconds = numberLengthCheck(date.getSeconds());
  return `${day} ${month} ${year} ${hours}:${minutes}:${seconds}`;
};

export const getIsAlarmedForMap = (mapGroup, mapId) => {
  const fromStorage = sessionStorage.getItem(
    sessionStorageKeys.SHOW_ALARMED_CAMS
  );

  if (fromStorage === null) {
    return true;
  }

  const parsedAlarmedStructure = JSON.parse(fromStorage);

  const requiredMapGroup = parsedAlarmedStructure[mapGroup];
  if (!requiredMapGroup) {
    return true;
  }

  const requiredMap = requiredMapGroup[mapId];

  if (requiredMap === undefined) {
    return true;
  }

  return requiredMap;
};

export const setIsAlarmedForMap = (mapGroup, mapId, value) => {
  let fromStorage = sessionStorage.getItem(
    sessionStorageKeys.SHOW_ALARMED_CAMS
  );

  if (fromStorage === null) {
    fromStorage = "{}";
  }

  const parsedAlarmedStructure = JSON.parse(fromStorage);

  if (!parsedAlarmedStructure[mapGroup]) {
    parsedAlarmedStructure[mapGroup] = {};
  }

  parsedAlarmedStructure[mapGroup][mapId] = value;

  sessionStorage.setItem(
    sessionStorageKeys.SHOW_ALARMED_CAMS,
    JSON.stringify(parsedAlarmedStructure)
  );
};

export const transformLocalViews = localViewsArray => {
  let isChanged = false;

  if (!localViewsArray) {
    return {
      isChanged: true,
      localViewsArray: []
    };
  }

  localViewsArray.forEach(localView => {
    if (String(localView.id).startsWith(LOCAL_VIEW_ID_PREFIX)) {
      return;
    }

    localView.id = LOCAL_VIEW_ID_PREFIX + localView.id;
    isChanged = true;
  });

  return {
    isChanged,
    localViewsArray
  };
};

export const getViewName = (view, translate) => {
  if (view.isGlobalView) {
    return `${translate(view.name)} ${translate("global.globalView")}`;
  }

  return translate(view.name);
};

export const getLangsForSelect = translates => {
  return Object.keys(translates)
    .filter(key => key.indexOf("langAbr") === 0)
    .reduce((langList, lang) => {
      const langValue = lang.split(".")[1];
      langList.push({ name: langValue, title: lang });

      return langList;
    }, []);
};



// WEBPACK FOOTER //
// ./src/utils.js